import React from "react";
import { Typography } from "@mui/material";
import { Account } from "@rentablo/api/apiv1";
import { toCurrency } from "@helpers/numberFormat";
import { AccountRow, AccountInfo } from "./components";

interface Props {
  account: Account;
  isReference: boolean;
  isLast?: boolean;
}

export const RequiredAccountRow = ({ account, isReference, isLast }: Props) => (
  <AccountRow isLast={isLast}>
    <AccountInfo account={account} isReference={isReference} />
    {account.balance != null && (
      <Typography variant="body2" fontWeight={600}>
        {toCurrency(account.balance, account.currency)}
      </Typography>
    )}
  </AccountRow>
);
